// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ruc: CountryValidator<"NI"> = createValidator(
  "ni.ruc",
  133,
);

export default ruc;
export const compact = ruc.compact;
export const format = ruc.format;
export const validate = ruc.validate;
export const generate = (): string =>
  ruc.generate?.() ??
  (() => {
    throw new Error(
      "Validator ni.ruc cannot generate values",
    );
  })();
